<div class="office-search">
    <div class="container default-container">
        <div class="row">
            <div class="field field-classification col-auto row">
                <select-dropdown class="searchType" [options]="optionsTitle" [selected]="selectedSearchType"
                    (changeSelectedValue)="onChangeSearchType($event)">
                </select-dropdown>
            </div>
            <div class="field field-input col row">
                <input type="text" class="search-key col" id="searchValue" [(ngModel)]="searchKey"
                    (keydown.enter)="onSearch()">
            </div>
            <div class="field submit-wrapper col-auto row">
                <a class="w-btn prime-btn submit-btn" id="btnSearch" (click)="onSearch()">
                    <span>{{'common.009' | translate}}</span>
                    <i class="bi bi-search"></i>
                </a>
            </div>
        </div>
    </div>
</div>

<div class="container mobile-container office-result">
    <div class="mobile-block last none">
        <div class="row media-center">
            <div class="col-auto item" *ngFor="let item of collection | paginate: config;">
                <a (click)="handleOnClickBoardNo(item.boardNo)">
                    <div class="thumbnail">
                        <div class="img-wrapper">
                            <img src="{{item.pathImg}}">
                        </div>
                    </div>
                    <!-- <div class="acaCont">
                        <h4 class="h-false post-name">{{item.title}}</h4>
                        <p>read more &raquo;</p>
                    </div>
                    <div class="post-meta">
                        <span>thejogak</span>
                        <span class="time">{{item.insDate}}</span>
                    </div> -->
                </a>
            </div>
        </div>        
        <paging
        [len]="len"
        [page]="page"
        [config]="config"
        [totalItems]="totalItems"
        (changePage)="handleOnChangePage($event)"
        (totalPage)="onTotalPage($event)"
        (changeLen)="handleOnChangeSelectedValue($event)"
        [turnOnTotalPage]="true"
        [turnOnPagination]="true"
        [turnOnTotalItem]="true"
        [isMobile]="false"
        [pdtLen]="true"
    ></paging>
    </div>
</div>